module.exports = __webpack_public_path__ + "static/ross-a38bfdbe5a7901edfe4e1fc8c3030527.png";